/* Colour-quiz lead attribution + conversion event.

   The Meta pixel is installed through the Facebook & Instagram app, which
   Shopify runs inside a sandboxed web pixel. `fbq` does not exist in theme
   scope, so calling fbq('track', ...) here would throw and Meta would receive
   nothing. Instead we publish a Shopify custom event, and a custom pixel in
   Settings > Customer events forwards CompleteRegistration to Meta. */
(function(){
  var SRC = 'sa_cq_src', CAMP = 'sa_cq_camp', EVENT = 'colour_quiz_signup';

  /* Breadcrumb, so a failure is visible instead of silent. After a sign-up read
     it with: sessionStorage.getItem('sa_cq_debug') */
  function note(msg){
    try { sessionStorage.setItem('sa_cq_debug', new Date().toISOString() + ' ' + msg); } catch(e){}
  }

  function slug(v){
    return String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 24);
  }
  function keep(key, val){
    try { if (val) sessionStorage.setItem(key, val); return val || sessionStorage.getItem(key) || ''; }
    catch(e){ return val || ''; }
  }

  var p = null, src = '', camp = '';
  try { p = new URLSearchParams(location.search); } catch(e){}
  if (p) {
    src = slug(p.get('utm_source'));
    camp = slug(p.get('utm_campaign'));
    if (!src && p.get('fbclid')) src = 'facebook';
    if (!src && p.get('ttclid')) src = 'tiktok';
    if (!src && p.get('gclid')) src = 'google';
  }
  if (!src) {
    try {
      var ref = document.referrer || '';
      if (ref && ref.indexOf(location.host) === -1) src = slug(ref.replace(/^https?:\/\/(www\.)?/, '').split('/')[0]);
    } catch(e){}
  }
  src = keep(SRC, src);
  camp = keep(CAMP, camp);

  function season(){
    try { return sessionStorage.getItem('sa_cq_season') || ''; } catch(e){ return ''; }
  }

  function attach(){
    var form = document.querySelector('#sa-cq-signup, form.sa-cq__form');
    if (!form || form.dataset.saCqTracked) return;
    form.dataset.saCqTracked = '1';
    form.addEventListener('submit', function(){
      var tags = form.querySelector('[data-cq-tags]');
      if (!tags) return;
      var have = tags.value.split(',').map(function(t){ return t.trim(); }).filter(Boolean);
      if (src && have.indexOf('src-' + src) === -1) have.push('src-' + src);
      if (camp && have.indexOf('camp-' + camp) === -1) have.push('camp-' + camp);
      tags.value = have.join(', ');
    });
  }

  /* This file is deferred, so Shopify's pixel layer may not have initialised
     yet. Retry for up to 15 seconds rather than failing silently. */
  function publishWhenReady(payload, tries){
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(EVENT, payload);
        note('published on attempt ' + tries);
        return;
      }
    } catch(e){ note('publish threw on attempt ' + tries + ': ' + e.message); return; }
    if (tries < 60) { setTimeout(function(){ publishWhenReady(payload, tries + 1); }, 250); return; }
    note('gave up after 15s: Shopify.analytics.publish never became available');
  }

  function lead(){
    var payload = {
      source: src || '(none)',
      campaign: camp || '(none)',
      season: season() || '(unknown)',
      page: 'colour-quiz'
    };
    note('sign-up detected, publishing');
    publishWhenReady(payload, 0);
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: EVENT, quiz_source: payload.source, quiz_campaign: payload.campaign });
    } catch(e){}
  }

  function boot(){
    attach();
    if (/customer_posted=true/.test(location.search)) lead();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', attach);
})();